export default __webpack_public_path__ + "static/media/madame_detail7.84079954.jpg";